// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import cn from 'classnames';
import {Button} from '../../../../hola/pub/lib/button';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import Svg_empty_plans from '../../img/dashboard/empty_plans.svg';
import styles from '../../pages/toolip.io/dashboard.module.less';

export const Empty_plans = ()=>{
    const {theme} = useContext(Settings_context);
    return <div className={cn(styles.empty_block, styles.empty_plans)}>
      <Svg_empty_plans/>
      <div className={styles.text_wrapper}>
        <p className={cn(theme.p2, theme.med, theme.color_n600)}>
          You currently don't have any active Proxy plans
        </p>
        <p className={cn(theme.p4, theme.color_n400)}>
          Check out our Proxy package options and choose the right one for you!
        </p>
      </div>
      <Button caption="Select plan" color={'black'} target="_blank" as_external
        to={'/pricing'} size={'sm'} round={false}/>
    </div>;
};
